/* eslint-disable */
import { FC, useEffect, useState } from "react";
import * as Yup from "yup";
import {
  Button,
  Grid,
  Typography,
  TextField,
  Box,
  CircularProgress,
  FormHelperText,
  Dialog,
  IconButton
} from "@material-ui/core";
import useAuth from "src/hooks/useAuth";
import { Formik } from "formik";
import { sendErp, updateFirstStep } from "../bridges/BrigdeUser";
import { useTranslation } from 'react-i18next';
import XIcon from "src/icons/X";
import documentRelease from "../../assets/img/cloud-document.svg";
import accessRelease from "../../assets/img/access-release.svg";
import accessSendedRelease from "../../assets/img/access-sended.svg";
import step1 from "../../assets/img/step1.svg";
import step2 from "../../assets/img/step2.svg";
import step3 from "../../assets/img/step3.svg";
import step2Gray from "../../assets/img/step2-grey.svg";
import step3Gray from "../../assets/img/step3-grey.svg";
import success from "../../assets/img/success.svg";
import useIndicators from "src/hooks/useIndicators";

interface IModalContractProps { }

const ModalPreUsed: FC<IModalContractProps> = (props) => {
  const { firstStep, getFirstStep } = useIndicators();
  const { t } = useTranslation('dashboard');
  const { user } = useAuth();
  const [modalOpen, setModalOpen] = useState(true);
  const [step, setStep] = useState(0);
  let visibleModal = window.localStorage.getItem("firstStep");

  const handleClose = () => {
    setModalOpen(false);
  };

  const handleLastStep = async () => {
    try {
      let obj = {
        businessId: user["businessId"]["business_id"],
        firstStep: false,
      };
      await updateFirstStep(obj);
      handleClose();
      window.location.reload();
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    visibleModal = window.localStorage.getItem("firstStep");
    if (visibleModal === "1") {
      getFirstStep(false);
    }

    if (visibleModal === "2" || visibleModal === "3") {
      getFirstStep(true);
    }
  }, [firstStep]);

  return (
    /* prettier-ignore */
    <>
      {user.firstStepContract !== null && user.firstStepContract !== undefined &&
        <>
          {firstStep === null ||
            firstStep === true ? (
            <Dialog open={modalOpen} onClose={handleClose} fullWidth maxWidth={'md'} scroll="paper">
              <Box display="flex" justifyContent="flex-end">
                <IconButton onClick={handleClose}>
                  <XIcon fontSize="small" />
                </IconButton>
              </Box>
              {user.signedContratUrl === 'N/A' && (
                <Box sx={{ margin: 5 }}>
                  <Grid container p={5}>
                    <Grid
                      item
                      xs={12}
                      md={12}
                      display="flex"
                      justifyContent="center"
                    >
                      <Box
                        alt="Contract Release"
                        component="img"
                        src={documentRelease}
                        sx={{ width: '30%' }}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={12}
                      display="flex"
                      justifyContent="center"
                      pt={4}
                      pb={1}
                    >
                      <Typography
                        color="#405364"
                        fontWeight={900}
                        fontSize="24px"
                      >
                        {t('modalContract.tittle')}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={12}
                      display="flex"
                      justifyContent="center"
                      pb={5}
                    >
                      <Typography
                        color="#405364"
                        fontWeight={400}
                        fontSize="18px"
                      >
                        {t('modalContract.subTittle')}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={12}
                      display="flex"
                      justifyContent="flex-start"
                      py={2}
                      px={10}
                    >
                      <Box
                        alt="Contract Release"
                        component="img"
                        src={step1}
                        sx={{ width: '5%' }}
                      />
                      <Typography
                        color="#5d6b83"
                        fontWeight={400}
                        fontSize="20px"
                        pl={2}
                      >
                        {t('modalContract.num11')}&nbsp;
                        <span style={{ color: '#024787', fontWeight: 600 }}>
                          <a
                            style={{ color: '#024787', fontWeight: 600 }}
                            href="/dashboard/contract"
                            onClick={() => {
                              window.localStorage.setItem('firstStep', '1');
                              getFirstStep(false);
                            }}
                          >
                            {t('modalContract.num12')}
                          </a>
                        </span>
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={12}
                      display="flex"
                      justifyContent="flex-start"
                      py={2}
                      px={10}
                    >
                      <Box
                        alt="Contract Release"
                        component="img"
                        src={step2Gray}
                        sx={{ width: '4%' }}
                      />
                      <Typography
                        color="#5d6b83"
                        fontWeight={400}
                        fontSize="20px"
                        pl={2}
                      >
                        <span style={{ color: 'gray', fontWeight: 600 }}>
                          {t('modalContract.num21')}
                        </span>{' '}
                        {t('modalContract.num22')}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={12}
                      display="flex"
                      justifyContent="flex-start"
                      py={2}
                      px={10}
                    >
                      <Box
                        alt="Contract Release"
                        component="img"
                        src={step3Gray}
                        sx={{ width: '4%' }}
                      />
                      <Typography
                        color="#5d6b83"
                        fontWeight={400}
                        fontSize="20px"
                        pl={2}
                      >
                        {t('modalContract.num31')}&nbsp;
                        <span style={{ color: 'gray', fontWeight: 600 }}>
                          {t('modalContract.num32')}
                        </span>
                        &nbsp;{t('modalContract.num33')}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={12}
                      display="flex"
                      justifyContent="center"
                      py={5}
                    >
                      <Button
                        sx={{
                          backgroundColor: '#034787',
                          borderRadius: '64px',
                        }}
                        variant="contained"
                        onClick={handleClose}
                      >
                        {t('modalContract.button')}
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              )}
              {user.firstStepContract.email === null &&
                user.firstStepContract.notes === '' &&
                user.signedContratUrl !== 'N/A' && (
                  <>
                    {step === 0 && (
                      <Box sx={{ margin: 5 }}>
                        <Grid container p={5}>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="center"
                          >
                            <Box
                              alt="Contract Release"
                              component="img"
                              src={documentRelease}
                              sx={{ width: '30%' }}
                            />
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="center"
                            pt={4}
                            pb={1}
                          >
                            <Typography
                              color="#405364"
                              fontWeight={900}
                              fontSize="24px"
                            >
                              Estás a unos pasos de vivir la experiencia Release
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="center"
                            pb={5}
                          >
                            <Typography
                              color="#405364"
                              fontWeight={400}
                              fontSize="18px"
                            >
                              Completa los siguientes pasos para empezar
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="flex-start"
                            py={2}
                            px={10}
                          >
                            <Box
                              alt="Contract Release"
                              component="img"
                              src={success}
                              sx={{ width: '5%' }}
                            />
                            <Typography
                              color="#5d6b83"
                              fontWeight={400}
                              fontSize="20px"
                              pl={2}
                            >
                              Firma el contrato de{' '}
                              <span
                                style={{ color: '#024787', fontWeight: 600 }}
                              >
                                <a
                                  style={{
                                    color: '#024787',
                                    fontWeight: 600,
                                  }}
                                >
                                  Prestación de Servicios en Línea
                                </a>
                              </span>
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="flex-start"
                            py={2}
                            px={10}
                          >
                            <Box
                              alt="Contract Release"
                              component="img"
                              src={step2}
                              sx={{ width: '5%' }}
                            />
                            <Typography
                              color="#5d6b83"
                              fontWeight={400}
                              fontSize="20px"
                              pl={2}
                            >
                              <span
                                style={{ color: '#024787', fontWeight: 600 }}
                              >
                                <a
                                  style={{ color: '#024787', fontWeight: 600 }}
                                  href="#"
                                  onClick={() => {
                                    setStep(1);
                                  }}
                                >
                                  Brinda accesos
                                </a>
                              </span>{' '}
                              para conectarnos al ERP de tu empresa
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="flex-start"
                            py={2}
                            px={10}
                          >
                            <Box
                              alt="Contract Release"
                              component="img"
                              src={step3Gray}
                              sx={{ width: '4%' }}
                            />
                            <Typography
                              color="#5d6b83"
                              fontWeight={400}
                              fontSize="20px"
                              pl={2}
                            >
                              ¡Listo!{' '}
                              <span
                                style={{ color: 'Gray', fontWeight: 600 }}
                              >
                                Realiza el primer Trade
                              </span>{' '}
                              con tus proveedores
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="center"
                            py={5}
                          >
                            <Button
                              sx={{
                                backgroundColor: '#034787',
                                borderRadius: '64px',
                              }}
                              variant="contained"
                              onClick={handleClose}
                            >
                              COMPLETAR PASOS LUEGO
                            </Button>
                          </Grid>
                        </Grid>
                      </Box>
                    )}
                    {step === 1 && (
                      <Box sx={{ margin: 5 }}>
                        <Grid container p={5}>
                          {/* <Grid item xs={12} display="flex" justifyContent="center"> */}
                          <Formik
                            initialValues={{
                              email: '',
                              submit: null,
                            }}
                            validationSchema={Yup.object().shape({
                              email: Yup.string()
                                .email('Debe ser un correo válido')
                                .max(255)
                                .required('Email es requerido'),
                            })}
                            onSubmit={async (
                              values,
                              { setErrors, setStatus, setSubmitting }
                            ) => {
                              try {
                                values['businessId'] =
                                  user['businessId']['business_id'];
                                await sendErp(values);
                                setSubmitting(false);
                                window.localStorage.setItem('firstStep', '3');
                                setStep(2);
                                // nextStep();
                              } catch (err) {
                                console.error(err);
                                setStatus({ success: false });
                                setErrors({ submit: err.message });
                                setSubmitting(false);
                              }
                            }}
                          >
                            {({
                              errors,
                              handleBlur,
                              handleChange,
                              handleSubmit,
                              setFieldValue,
                              setFieldTouched,
                              isSubmitting,
                              touched,
                              values,
                            }) => (
                              <Box>
                                {isSubmitting ? (
                                  <Box
                                    display="flex"
                                    justifyContent="center"
                                    my={5}
                                  >
                                    <CircularProgress />
                                  </Box>
                                ) : (
                                  <form onSubmit={handleSubmit}>
                                    <Grid
                                      item
                                      xs={12}
                                      md={12}
                                      display="flex"
                                      justifyContent="center"
                                    >
                                      <Box
                                        alt="Contract Release"
                                        component="img"
                                        src={accessRelease}
                                        sx={{ width: '30%' }}
                                      />
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      md={12}
                                      display="flex"
                                      justifyContent="center"
                                      pt={4}
                                      pb={1}
                                    >
                                      <Typography
                                        color="#405364"
                                        fontWeight={900}
                                        fontSize="24px"
                                      >
                                        Brinda accesos para conectarnos al ERP
                                        de tu empresa
                                      </Typography>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      md={12}
                                      display="flex"
                                      justifyContent="center"
                                      py={3}
                                      px={10}
                                    >
                                      <Typography
                                        color="#405364"
                                        fontWeight={400}
                                        fontSize="18px"
                                      >
                                        Ingresa el correo del encargado de TI
                                        para indicarle el procedimiento y los
                                        accesos que necesitamos para conectar
                                        Release a tu empresa.
                                      </Typography>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      display="flex"
                                      justifyContent="center"
                                    >
                                      <TextField
                                        error={Boolean(
                                          touched.email && errors.email
                                        )}
                                        sx={{ width: '75%' }}
                                        helperText={
                                          touched.email && errors.email
                                        }
                                        label="Email"
                                        name="email"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.email}
                                        variant="outlined"
                                        autoComplete="off"
                                      />
                                    </Grid>
                                    {Boolean(errors.submit) && (
                                      <FormHelperText error>
                                        {errors.submit}
                                      </FormHelperText>
                                    )}
                                    <Box mt={2}>
                                      <Box
                                        display="flex"
                                        justifyContent="center"
                                        my={5}
                                      >
                                        <Button
                                          sx={{
                                            backgroundColor: '#034787',
                                            borderRadius: '64px',
                                            width: '240px',
                                          }}
                                          variant="contained"
                                          size="large"
                                          type="submit"
                                        >
                                          ENVIAR
                                        </Button>
                                      </Box>
                                    </Box>
                                  </form>
                                )}
                              </Box>
                            )}
                          </Formik>
                          {/* </Grid> */}
                        </Grid>
                      </Box>
                    )}
                    {step === 2 && (
                      <Box sx={{ margin: 5 }}>
                        <Grid container p={5}>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="center"
                          >
                            <Box
                              alt="Contract Release"
                              component="img"
                              src={accessSendedRelease}
                              sx={{ width: '30%' }}
                            />
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="center"
                            pt={4}
                            pb={1}
                          >
                            <Typography
                              color="#405364"
                              fontWeight={900}
                              fontSize="24px"
                            >
                              ¡Correo enviado con éxito!
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="center"
                            py={3}
                            px={10}
                          >
                            <Typography
                              color="#405364"
                              fontWeight={400}
                              fontSize="18px"
                              textAlign="center"
                            >
                              Una vez que el encargado de TI nos brinde los
                              accesos,{' '}
                              <span style={{ fontWeight: 600 }}>
                                tendrá que pasar 24 horas para que nuestro bot
                                extraiga la información contable que Release
                                requiere para operar.
                              </span>
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="center"
                            px={10}
                          >
                            <Typography
                              color="#405364"
                              fontWeight={400}
                              fontSize="18px"
                              textAlign="center"
                            >
                              Te avisaremos cuando se haya completado este paso
                              para que continúes con el proceso.
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="center"
                            py={5}
                          >
                            <Button
                              sx={{
                                backgroundColor: '#034787',
                                borderRadius: '64px',
                                width: '240px',
                              }}
                              onClick={() => {
                                setStep(0);
                                window.location.reload();
                              }}
                              variant="contained"
                              size="large"
                            >
                              CERRAR
                            </Button>
                          </Grid>
                          <Grid item xs={12}>
                            <Typography
                              textAlign="center"
                              color="#5d6b83"
                              fontSize="14px"
                              fontWeight={400}
                            >
                              ¿No recibió el correo?{' '}
                              <span
                                style={{
                                  textDecoration: 'underline',
                                  color: '#024787',
                                }}
                              >
                                <a
                                  style={{
                                    color: '#024787',
                                    fontWeight: 'bold',
                                  }}
                                  onClick={() => setStep(1)}
                                  href="#"
                                >
                                  Vuelve a enviarlo
                                </a>
                              </span>
                            </Typography>
                          </Grid>
                        </Grid>
                      </Box>
                    )}
                  </>
                )}
              {user.firstStepContract.email !== null &&
                user.firstStepContract.notes === '' &&
                user.signedContratUrl !== 'N/A' && (
                  <>
                    {step === 0 && (
                      <Box sx={{ margin: 5 }}>
                        <Grid container p={5}>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="center"
                          >
                            <Box
                              alt="Contract Release"
                              component="img"
                              src={documentRelease}
                              sx={{ width: '30%' }}
                            />
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="center"
                            pt={4}
                            pb={1}
                          >
                            <Typography
                              color="#405364"
                              fontWeight={900}
                              fontSize="24px"
                            >
                              Estás a unos pasos de vivir la experiencia Release
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="center"
                            pb={5}
                          >
                            <Typography
                              color="#405364"
                              fontWeight={400}
                              fontSize="18px"
                            >
                              Completa los siguientes pasos para empezar
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="flex-start"
                            py={2}
                            px={10}
                          >
                            <Box
                              alt="Contract Release"
                              component="img"
                              src={success}
                              sx={{ width: '5%' }}
                            />
                            <Typography
                              color="#5d6b83"
                              fontWeight={400}
                              fontSize="20px"
                              pl={2}
                            >
                              Firma el contrato de{' '}
                              <span
                                style={{ color: '#024787', fontWeight: 600 }}
                              >
                                <a
                                  style={{
                                    color: '#024787',
                                    fontWeight: 600,
                                  }}
                                >
                                  Prestación de Servicios en Línea
                                </a>
                              </span>
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="flex-start"
                            py={2}
                            px={10}
                          >
                            <Box
                              alt="Contract Release"
                              component="img"
                              src={step2}
                              sx={{ width: '5%' }}
                            />
                            <Typography
                              color="#5d6b83"
                              fontWeight={400}
                              fontSize="20px"
                              pl={2}
                            >
                              <span
                                style={{ color: '#024787', fontWeight: 600 }}
                              >
                                <a
                                  style={{ color: '#024787', fontWeight: 600 }}
                                  href="#"
                                  onClick={() => {
                                    setStep(1);
                                  }}
                                >
                                  Brinda accesos
                                </a>
                              </span>{' '}
                              para conectarnos al ERP de tu empresa
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="flex-start"
                            py={2}
                            px={10}
                          >
                            <Box
                              alt="Contract Release"
                              component="img"
                              src={step3Gray}
                              sx={{ width: '4%' }}
                            />
                            <Typography
                              color="#5d6b83"
                              fontWeight={400}
                              fontSize="20px"
                              pl={2}
                            >
                              ¡Listo!{' '}
                              <span
                                style={{ color: 'gray', fontWeight: 600 }}
                              >
                                Realiza el primer Trade
                              </span>{' '}
                              con tus proveedores
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="center"
                            py={5}
                          >
                            <Button
                              sx={{
                                backgroundColor: '#034787',
                                borderRadius: '64px',
                              }}
                              variant="contained"
                              onClick={handleClose}
                            >
                              COMPLETAR PASOS LUEGO
                            </Button>
                          </Grid>
                        </Grid>
                      </Box>
                    )}
                    {step === 1 && (
                      <Box sx={{ margin: 5 }}>
                        <Grid container p={5}>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="center"
                          >
                            <Box
                              alt="Contract Release"
                              component="img"
                              src={accessSendedRelease}
                              sx={{ width: '30%' }}
                            />
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="center"
                            pt={4}
                            pb={1}
                          >
                            <Typography
                              color="#405364"
                              fontWeight={900}
                              fontSize="24px"
                            >
                              ¡Correo enviado con éxito!
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="center"
                            py={3}
                            px={10}
                          >
                            <Typography
                              color="#405364"
                              fontWeight={400}
                              fontSize="18px"
                              textAlign="center"
                            >
                              Una vez que el encargado de TI nos brinde los
                              accesos,{' '}
                              <span style={{ fontWeight: 600 }}>
                                tendrá que pasar 24 horas para que nuestro bot
                                extraiga la información contable que Release
                                requiere para operar.
                              </span>
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="center"
                            px={10}
                          >
                            <Typography
                              color="#405364"
                              fontWeight={400}
                              fontSize="18px"
                              textAlign="center"
                            >
                              Te avisaremos cuando se haya completado este paso
                              para que continúes con el proceso.
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="center"
                            py={5}
                          >
                            <Button
                              sx={{
                                backgroundColor: '#034787',
                                borderRadius: '64px',
                                width: '240px',
                              }}
                              onClick={handleClose}
                              variant="contained"
                              size="large"
                            >
                              CERRAR
                            </Button>
                          </Grid>
                          <Grid item xs={12}>
                            <Typography
                              textAlign="center"
                              color="#5d6b83"
                              fontSize="14px"
                              fontWeight={400}
                            >
                              ¿No recibió el correo?{' '}
                              <span
                                style={{
                                  textDecoration: 'underline',
                                  color: '#024787',
                                }}
                              >
                                <a
                                  style={{
                                    color: '#024787',
                                    fontWeight: 'bold',
                                  }}
                                  href="#"
                                  onClick={() => {
                                    setStep(2);
                                  }}
                                >
                                  Vuelve a enviarlo
                                </a>
                              </span>
                            </Typography>
                          </Grid>
                        </Grid>
                      </Box>
                    )}
                    {step === 2 && (
                      <Box sx={{ margin: 5 }}>
                        <Grid container p={5}>
                          {/* <Grid item xs={12} display="flex" justifyContent="center"> */}
                          <Formik
                            initialValues={{
                              email: '',
                              submit: null,
                            }}
                            validationSchema={Yup.object().shape({
                              email: Yup.string()
                                .email('Debe ser un correo válido')
                                .max(255)
                                .required('Email es requerido'),
                            })}
                            onSubmit={async (
                              values,
                              { setErrors, setStatus, setSubmitting }
                            ) => {
                              try {
                                values['businessId'] =
                                  user['businessId']['business_id'];
                                await sendErp(values);
                                setSubmitting(false);
                                window.localStorage.setItem('firstStep', '3');
                                setStep(1);
                                // nextStep();
                              } catch (err) {
                                console.error(err);
                                setStatus({ success: false });
                                setErrors({ submit: err.message });
                                setSubmitting(false);
                              }
                            }}
                          >
                            {({
                              errors,
                              handleBlur,
                              handleChange,
                              handleSubmit,
                              setFieldValue,
                              setFieldTouched,
                              isSubmitting,
                              touched,
                              values,
                            }) => (
                              <Box>
                                {isSubmitting ? (
                                  <Box
                                    display="flex"
                                    justifyContent="center"
                                    my={5}
                                  >
                                    <CircularProgress />
                                  </Box>
                                ) : (
                                  <form onSubmit={handleSubmit}>
                                    <Grid
                                      item
                                      xs={12}
                                      md={12}
                                      display="flex"
                                      justifyContent="center"
                                    >
                                      <Box
                                        alt="Contract Release"
                                        component="img"
                                        src={accessRelease}
                                        sx={{ width: '30%' }}
                                      />
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      md={12}
                                      display="flex"
                                      justifyContent="center"
                                      pt={4}
                                      pb={1}
                                    >
                                      <Typography
                                        color="#405364"
                                        fontWeight={900}
                                        fontSize="24px"
                                      >
                                        Brinda accesos para conectarnos al ERP
                                        de tu empresa
                                      </Typography>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      md={12}
                                      display="flex"
                                      justifyContent="center"
                                      py={3}
                                      px={10}
                                    >
                                      <Typography
                                        color="#405364"
                                        fontWeight={400}
                                        fontSize="18px"
                                      >
                                        Ingresa el correo del encargado de TI
                                        para indicarle el procedimiento y los
                                        accesos que necesitamos para conectar
                                        Release a tu empresa.
                                      </Typography>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      display="flex"
                                      justifyContent="center"
                                    >
                                      <TextField
                                        error={Boolean(
                                          touched.email && errors.email
                                        )}
                                        sx={{ width: '75%' }}
                                        helperText={
                                          touched.email && errors.email
                                        }
                                        label="Email"
                                        name="email"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.email}
                                        variant="outlined"
                                        autoComplete="off"
                                      />
                                    </Grid>
                                    {Boolean(errors.submit) && (
                                      <FormHelperText error>
                                        {errors.submit}
                                      </FormHelperText>
                                    )}
                                    <Box mt={2}>
                                      <Box
                                        display="flex"
                                        justifyContent="center"
                                        my={5}
                                      >
                                        <Button
                                          sx={{
                                            backgroundColor: '#034787',
                                            borderRadius: '64px',
                                            width: '240px',
                                          }}
                                          variant="contained"
                                          size="large"
                                          type="submit"
                                        >
                                          ENVIAR
                                        </Button>
                                      </Box>
                                    </Box>
                                  </form>
                                )}
                              </Box>
                            )}
                          </Formik>
                          {/* </Grid> */}
                        </Grid>
                      </Box>
                    )}
                  </>
                )}
              {user.firstStepContract.email !== null &&
                user.firstStepContract.notes !== '' &&
                user.signedContratUrl !== 'N/A' && (
                  <Box sx={{ margin: 5 }}>
                    <Grid container p={5}>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        display="flex"
                        justifyContent="center"
                      >
                        <Box
                          alt="Contract Release"
                          component="img"
                          src={documentRelease}
                          sx={{ width: '30%' }}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        display="flex"
                        justifyContent="center"
                        pt={4}
                        pb={1}
                      >
                        <Typography
                          color="#405364"
                          fontWeight={900}
                          fontSize="24px"
                        >
                          Estás a unos pasos de vivir la experiencia Release
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        display="flex"
                        justifyContent="center"
                        pb={5}
                      >
                        <Typography
                          color="#405364"
                          fontWeight={400}
                          fontSize="18px"
                        >
                          Completa los siguientes pasos para empezar
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        display="flex"
                        justifyContent="flex-start"
                        py={2}
                        px={10}
                      >
                        <Box
                          alt="Contract Release"
                          component="img"
                          src={success}
                          sx={{ width: '5%' }}
                        />
                        <Typography
                          color="#5d6b83"
                          fontWeight={400}
                          fontSize="20px"
                          pl={2}
                        >
                          Firma el contrato de{' '}
                          <span style={{ color: '#024787', fontWeight: 600 }}>
                            <a
                              style={{
                                color: '#024787',
                                fontWeight: 600,
                              }}
                            >
                              Prestación de Servicios en Línea
                            </a>
                          </span>
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        display="flex"
                        justifyContent="flex-start"
                        py={2}
                        px={10}
                      >
                        <Box
                          alt="Contract Release"
                          component="img"
                          src={success}
                          sx={{ width: '5%' }}
                        />
                        <Typography
                          color="#5d6b83"
                          fontWeight={400}
                          fontSize="20px"
                          pl={2}
                        >
                          <span style={{ color: '#024787', fontWeight: 600 }}>
                            <a style={{ color: '#024787', fontWeight: 600 }}>
                              Brinda accesos
                            </a>
                          </span>{' '}
                          para conectarnos al ERP de tu empresa
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        display="flex"
                        justifyContent="flex-start"
                        py={2}
                        px={10}
                      >
                        <Box
                          alt="Contract Release"
                          component="img"
                          src={step3}
                          sx={{ width: '5%' }}
                        />
                        <Typography
                          color="#5d6b83"
                          fontWeight={400}
                          fontSize="20px"
                          pl={2}
                        >
                          ¡Listo!{' '}
                          <span style={{ color: '#024787', fontWeight: 600 }}>
                            Realiza el primer Trade
                          </span>{' '}
                          con tus proveedores
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        display="flex"
                        justifyContent="center"
                        py={5}
                      >
                        <Button
                          sx={{
                            backgroundColor: '#034787',
                            borderRadius: '64px',
                          }}
                          variant="contained"
                          onClick={handleLastStep}
                        >
                          COMENZAR
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                )}

            </Dialog>
          ) : null}</>}
    </>
  );
};

ModalPreUsed.propTypes = {};

export default ModalPreUsed;
